// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/hooks/useRestoreFocus.js

import { useEffect, useRef } from "react";

export default function useRestoreFocus(active) {
  const triggerRef = useRef(null);

  useEffect(() => {
    if (!active || typeof document === "undefined") return undefined;

    triggerRef.current = document.activeElement;

    return () => {
      const target = triggerRef.current;

      window.requestAnimationFrame(() => {
        if (target && typeof target.focus === "function" && target.isConnected) {
          target.focus();
        }
      });
    };
  }, [active]);
}
